import React from 'react';
import {
	Table,
	Input,
	Button,
	Row,
	Col,
	Card,
	CardBody,
	ButtonGroup,
} from 'reactstrap';
import { Bubble } from 'react-chartjs-2';
import ClientsList from '../components/ClientsList';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormatNumberInEur, FormatPercentage } from '../components/Utils'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ChartDataAnnotations from 'chartjs-plugin-annotation';
import Legend from '../components/Legend';
import Http from '../Http';
var _ = require('lodash');

class Mappa extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			modalMini: false,
			showChart: false,
			chartData: {
				labels: ['Data'],
				datasets: [],
			},
			chartOptions: {
				legend: {
					display: false
				},
				tooltips: {
					mode: 'nearest',
					callbacks: {
						label: function (tooltipItem, data) {
							if (data.datasets[tooltipItem.datasetIndex].label != "Scostamento") {
								return data.datasets[tooltipItem.datasetIndex].label
							}
						},
						afterLabel: function (tooltipItem, data) {
							if (data.datasets[tooltipItem.datasetIndex].label != "Scostamento") {
								let arr = ["",
									"EXP: " + data.datasets[tooltipItem.datasetIndex].data[0].x_label,
									"CPF: " + data.datasets[tooltipItem.datasetIndex].data[0].y,
									"Fatturato: " + FormatNumberInEur(data.datasets[tooltipItem.datasetIndex].data[0].r_label, false)]
								return arr;
							} else {
								return []
							}


						}
					}

				},
				cornerRadius: 20,
				scales: {
					xAxes: [{
						gridLines: {
							display: true,
							drawBorder: true
						},
						ticks: {
							stepSize: 10,
							min: 0,
							max: 90,
							precision: 0.01,
							fontColor: "#fff"
						},
						scaleLabel: {
							display: true,
							labelString: 'EXP',
							padding: 10,
							fontColor: "#fff"
						}
					}],
					yAxes: [{
						gridLines: {
							display: true,
							drawBorder: true
						},
						ticks: {
							fontColor: "#fff"
						},
						scaleLabel: {
							display: true,
							labelString: 'Coefficiente Potenza di Fuoco',
							padding: 10,
							fontColor: "#fff"
						}
					}]
				},
				layout: {
					padding: {
						left: 50,
						right: 50,
						top: 0,
						bottom: 0
					}
				}
			},
			activeYear: this.props.user.reports.newestReportYear,
			activeSource: 'original',
			clientsData: [],
			saveButtonClass: '',
			chartCol: "12",
			legendCollapsed: false,
		}

		this.toggleChart = this.toggleChart.bind(this)
		this.api = '/api/v1';

		this.years = []
		let year = this.props.user.reports.newestReportYear
		while (year >= this.props.user.reports.firstCoeffYear) {
			this.years.push(year)
			year--
		}
	}

	componentDidMount() {
		//margin bottom under legend
		Chart.plugins.register({
			beforeInit: function (chart, options) {
				chart.legend.afterFit = function () {
					this.height = this.height + 50;
				};
			}
		});
		Chart.plugins.register(ChartDataAnnotations);
		Chart.plugins.unregister(ChartDataLabels);
	}

	loadDataChart() {
		let datasets = []
		const { activeYear } = this.state
		this.state.clientsData.map((client) => {
			if (client.mappa[activeYear]) {
				datasets.push(
					{
						label: client.name,
						lineTension: 0,
						backgroundColor: 'rgba(' + client.color + ',0.8)',
						borderWidth: 0,
						data: [client.mappa[activeYear]]
					})
			}
		})
		let { chartData, chartOptions } = this.state
		chartData.datasets = datasets
		//set xy min max
		chartOptions.scales.yAxes[0].ticks.min = this.state.clientsData[0].chartCPFMin - 2
		chartOptions.scales.yAxes[0].ticks.max = this.state.clientsData[0].chartCPFMax + 2
		this.setState({
			chartData,
			chartOptions,
			showChart: true,
		})
	}


	toggleChart(cleanedData) {
		window.scrollTo(0, 0);
		if (this.state.showChart) {
			this.setState({
				showChart: false,
				chartCol: "12",
				legendCollapsed: false
			})
		} else {
			this.setState({
				clientsData: cleanedData,
			})
			this.loadDataChart()
		}
	}

	//async await perchè il grafico veniva caricato prima del cambio stato
	async handleYearButtonClick(year) {
		await this.setState({ activeYear: year })
		this.loadDataChart()
	}


	resizeChartCol() {
		let { legendCollapsed } = this.state
		this.setState({
			legendCollapsed: !legendCollapsed,
			chartCol: !legendCollapsed ? "9" : "12"
		})
	}

	renderChart() {
		let current = this.state.activeYear;
		let { clientsData, chartData, chartOptions, chartCol, legendCollapsed } = this.state
		let getClass = function (year) {
			if (year === current)
				return 'btn-primary';
			return '';
		};
		let yearsMappa = this.props.user.settoriale == 1 ? this.years : this.years.slice(0, 3)

		return (
			<>

				<Row>
					<Col md="3">
						<Legend clientsData={clientsData} vertical={true} resize={() => { this.resizeChartCol() }} />
					</Col>
					<Col md="9 text-center">
						<Card>
							<CardBody>
								<Row>
									<Col md="12">
										<ButtonGroup>
											{yearsMappa.map((year, index) => {
												return (<Button key={index} onClick={this.handleYearButtonClick.bind(this, year)} className={getClass(year) + " px-1"}>{year}</Button>)
											})}
										</ButtonGroup>
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Col>
					<Col md={{ size: chartCol, offset: legendCollapsed ? "3" : "0" }} >
						<Card>
							<CardBody>
								<Bubble data={chartData} options={chartOptions} />
							</CardBody>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col md="12">
						<div className="clearfix">
							<Button className="animation-on-hover float-right text-center ml-3" color="secondary" onClick={this.toggleChart}>Torna indietro</Button>
						</div>
					</Col>
				</Row>
			</>
		)
	}

	render() {
		let { showChart } = this.state
		return (
			<div className="content">
				{showChart === false ? (
					<ClientsList
						{...this.props}
						maxCheckboxes={-1}
						onDataDownloaded={this.toggleChart}
						btnTitle={"Crea grafico"}
						type={"mappa"}
					/>
				) : (
					this.renderChart()
				)}
			</div >
		)
		// }
	}
}

Mappa.propTypes = {
	dispatch: PropTypes.func.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(Mappa);